module.exports = __webpack_public_path__ + "static/media/loading-page-image-jetblue.9a3092cb.svg";